export const FEATURE_FLAGS = {
  HIDDEN_WIDGET_FIELDS: 'UITEAM-667-hidden-widget-fields',
  SHOW_APP_NAV: 'UITEAM-698-update-app-nav-hub',
  APP_STUDIO: 'ask-7-app-studio-app-type',
  ASK_118_EM_INSTANCE: 'ASK-118-EM-INSTANCE',
  LLM_PLAYGROUND: 'SSS-876-llm-playground',
  CONFIG_PROMOTION: 'CSQ-949-configuration-promotion-tab',
  SHOW_SITES_PAGE: 'csq-1065-sites-page',
  APP_STUDIO_WIZARD_MODEL_TASK_DROPDOWN: 'APST-113-Model-Task-Dropdown',
  SHOW_SUPPORT_WIDGET: 'KUMO-184-support-question-mark',
  SET_MIN_MAX_REPLICAS: 'LWAI-584-ff-min-max-replicas-for-deployments',
  SHOW_FAKE_CONVERSATIONAL_QNA_AGENT: 'LWAI-544-conversational-qna-wizard',
  SHOW_FUTURE_DATA_CONNECTORS: 'LWAI-500-show-future-data-connectors',
  SHOW_COMING_SOON_COMPONENTS: 'LWAI-500-show-coming-soon-components',
  CUSTOM_MODEL_CREATION: 'LWAI-1218-custom-model-creation',
  AGENT_ANALYTICS: 'LWAI-1153-agent-analytics',
  MODEL_COMPARISON: 'LWAI-1432-model-comparison',
};

export interface LDUser {
  email: string;
  customerId: string;
}